import generateRender from 'shared/utils/generateRender';
import DefaultPreloader from './DefaultPreloader';
import HriPreloader from './HriPreloader';
import WidePreloader from './WidePreloader';
import LadyluckPreloader from './LadyluckPreloader';

const AssetPreloader = generateRender({
  default: DefaultPreloader,
  hri: HriPreloader,
  millelacs: WidePreloader,
  sga: WidePreloader,
  ladyluck: LadyluckPreloader,
});

export default AssetPreloader;
